export default "__VITE_PUBLIC_ASSET__c6ee54b8__"